'use strict'

class Null {
  constructor() {
    Object.seal(this)
  }
}

const NULL = new Null()

const isNull = (param) => param instanceof Null

export const CollaboratorFabric = ({ data = [] }) => data.map((e) => new Collaborator({ ...e }));

export class Collaborator {
  constructor({
    id = NULL,
    name = NULL,
    type = NULL,
    isSelected = false,
  } = {}) {
    this.id = isNull(id) ? null : id;
    this.name = isNull(name) ? null : name;
    this.type = isNull(type) ? null : type;
    this.isSelected = isNull(isSelected) ? null : isSelected;
  }

  copyWith({
    id = NULL,
    name = NULL,
    type = NULL,
    isSelected = false,
  } = {}) {
    return new Collaborator({
      id: isNull(id) ? this.id : id,
      name: isNull(name) ? this.name : name,
      type: isNull(type) ? this.type : type,
      isSelected: isNull(isSelected) ? this.type : isSelected,
    })
  }
}

export class CreateHost {
  constructor({
    name = NULL
  } = {}) {
    this.name = isNull(name) ? null : name

  }

  copyWith({
    name = NULL
  } = {}) {
    return new CreateHost({
      name: isNull(name) ? this.name : name
    })
  }
}


export class GenerateQrCheckIn {
  constructor({
    reason = NULL,
    firstName = NULL,
    lastName = NULL,
    email = NULL,
    id = NULL,
    type = NULL
  } = {}) {
    this.person = {}
    this.visitHosts = [{}]
    this.reason = isNull(reason) ? null : reason;
    this.person.firstName = isNull(firstName) ? null : firstName;
    this.person.lastName = isNull(lastName) ? null : lastName;
    this.person.email = isNull(email) ? null : email;
    this.visitHosts[0].id = isNull(id) ? null : id;
    this.visitHosts[0].type = isNull(type) ? null : type
    Object.seal(this)
  }

  copyWith({
    reason = NULL,
    firstName = NULL,
    lastName = NULL,
    email = NULL,
    id = NULL,
    type = NULL
  } = {}) {
    return new GenerateQrCheckIn({
      reason: isNull(reason) ? this.reason : reason,
      firstName: isNull(firstName) ? this.firstName : firstName,
      lastName: isNull(lastName) ? this.lastName : lastName,
      email: isNull(email) ? this.email : email,
      id: isNull(id) ? this.id : id,
      type: isNull(type) ? this.type : type
    })
  }
}


export class GeneratedCheckInResponse {
  constructor({
    peopleCount = NULL,
    deleted = NULL,
    linkedPoll = NULL,
    qr = NULL
  } = {}) {
    this.peopleCount = isNull(peopleCount) ? null : peopleCount;
    this.deleted = isNull(deleted) ? null : deleted;
    this.linkedPoll = isNull(linkedPoll) ? null : linkedPoll;
    this.qr = isNull(qr) ? null : qr
    Object.seal(this)
  }

  copyWith({
    peopleCount = NULL,
    deleted = NULL,
    linkedPoll = NULL,
    qr = NULL
  } = {}) {
    return new GeneratedCheckInResponse({
      peopleCount: isNull(peopleCount) ? this.peopleCount : peopleCount,
      deleted: isNull(deleted) ? this.deleted : deleted,
      linkedPoll: isNull(linkedPoll) ? this.linkedPoll : linkedPoll,
      qr: isNull(qr) ? this.qr : qr
    })
  }
}


export const generateImageFromBase64 = (base64 = '') => `data:image/png;base64,${base64}`;